import LacunaWebPKI from 'web-pki';
import { workspace } from '../../shared/api';

export const LacunaService = {
  listCertificates(): Promise<CertificateFromLacuna[]> {
    const pki = new LacunaWebPKI();
    return new Promise((resolve, reject) => {
      const callback = () => {
        // @ts-ignore
        pki.listCertificates().success(resolve).fail(reject);
      };
      // @ts-ignore por algum motivo ele está reclamando dos parametros que o callback recebe, mesmo sendo opcional
      pki.init({ ready: callback, notInstalled: onWebPkiNotInstalled });

      function onWebPkiNotInstalled() {
        reject('Extensão WebPKI não instalada');
      }
    });
  },
  readCertificate(thumbprint: string): Promise<string> {
    const pki = new LacunaWebPKI();
    return new Promise((resolve, reject) => {
      pki.readCertificate({ thumbprint }).success(resolve).fail(reject);
    });
  },
  signWithTokens(thumbprint: string, tokens: string[]) {
    const pki = new LacunaWebPKI();
    return new Promise<void>((resolve, reject) => {
      pki
        .preauthorizeSignatures({
          certificateThumbprint: thumbprint,
          signatureCount: tokens.length, // Number of signatures to be authorized by the user.
        })
        .success(async () => {
          const signToken = (token: string) =>
            new Promise((resolveSignature, rejectSignature) => {
              const params = {
                thumbprint,
                token,
              };
              pki.signWithRestPki(params).success(resolveSignature).fail(rejectSignature);
            });

          try {
            // O lote precisa ser sequencial: drivers de certificado (A3/smartcard) não suportam
            // operações concorrentes e uma falha em paralelo deixaria as demais assinaturas em voo,
            // gerando prescrição parcialmente assinada. É o padrão documentado pela Lacuna para
            // preauthorizeSignatures.
            for (const token of tokens) {
              await signToken(token);
            }
            resolve();
          } catch (e) {
            reject('Não foi possível assinar a prescrição, verifique seu certificado.');
          }
        })
        .fail(reject);
    });
  },
  filterExpiredCertificates(certificates: CertificateFromLacuna[]) {
    return certificates.filter((certificate) => new Date(certificate.validityEnd) > new Date());
  },
  async validateDocument(documents: { id: string; url: string }[]): Promise<LacunaDocumentValidation[]> {
    const params = {
      documentos: documents,
    };
    const { data } = await workspace.post(`/lacuna/validar-documentos`, params);
    return data.data;
  },
};
export interface ValidationResultsError {
  _message: string[];
}
export interface ValidationResults {
  _errors: ValidationResultsError[];
}
export interface SignatureDetail {
  _validationResults: ValidationResults;
}
export interface Validation {
  hasError: boolean;
  hasExpiredCertificate: boolean;
  hasRevokedCertificate: boolean;
  hasValidSignature: boolean;
  hasSignature: boolean;
  hasIndeterminateSignature: boolean;
  signatureDetails: SignatureDetail[];
}

export interface LacunaDocumentValidation {
  id: string;
  url: string;
  validation: Validation;
}

export interface PkiBrazil {
  certificateType: string;
  responsavel: string;
  isAplicacao: boolean;
  cpf: string | null;
  rgNumero?: any;
  nis?: any;
  oabNumero?: any;
  rgEmissor?: any;
  isPessoaFisica: boolean;
  rgEmissorUF?: any;
  oabUF?: any | null;
  companyName: string | null;
  cnpj: string | null;
  dateOfBirth: Date;
  isPessoaJuridica: boolean;
}

export interface KeyUsage {
  crlSign: boolean;
  dataEncipherment: boolean;
  decipherOnly: boolean;
  digitalSignature: boolean;
  encipherOnly: boolean;
  keyAgreement: boolean;
  keyCertSign: boolean;
  keyEncipherment: boolean;
  nonRepudiation: boolean;
}

export interface CertificateFromLacuna {
  email: string;
  pkiBrazil: PkiBrazil;
  subjectName: string;
  issuerName: string;
  thumbprint: string;
  keyUsage: KeyUsage;
  validityStart: Date;
  validityEnd: Date;
  canRemove: boolean;
}
